import React, { useState, useEffect } from "react";

import ApiEndpoints from "../../network/ApiEndPoints";
import { postJsonData } from "../../network/ApiController";
import { apiErrorToast, okSuccessToast } from "../../utils/ToastUtil";
import ModalHeader from "../../modals/ModalHeader";
import { Box, Button, Grid, Modal, TextField } from "@mui/material";
import ModalFooter from "../../modals/ModalFooter";
import Loader from "../../component/loading-screen/Loader";
import { IconButton, Stack } from "@mui/material";
import { Delete, Person } from "@mui/icons-material";
const DeleteUtil = ({ getUtil, row }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ type: "", name: "" });
  const [open, setOpen] = useState(false);

  // Set initial values when the modal opens
  useEffect(() => {
    if (row) {
      setFormData({ type: row.type || "", name: row.name || "" });
    }
  }, [row, open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleClose = () => {
    setOpen(false);
    setFormData({ type: "", name: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.type || !formData.name) {
      apiErrorToast("Both fields are required!");
      return;
    }

    setLoading(true);
    postJsonData(
      `${ApiEndpoints.DELETE_UTILS}/${row.id}`,
      formData,
      setLoading,
      (res) => {
        okSuccessToast(res.data.message);
        getUtil();
        setLoading(false);
        handleClose();
      },
      (error) => {
        apiErrorToast(error);
        setLoading(false);
      }
    );
  };

  return (
    <>
      <IconButton onClick={() => setOpen(true)} color="error">
        <Delete fontSize="small" />
      </IconButton>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 700,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Loader request={loading} />
          <ModalHeader
            title=" Delete Util"
            handleClose={handleClose}
            subtitle="Delete Utility"
          />

          <form onSubmit={handleSubmit} id="delete-util">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Type"
                  name="type"
                  value={formData.type}
                  onChange={handleChange}
                  margin="normal"
                  required
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  margin="normal"
                  required
                />
              </Grid>
            </Grid>
          </form>

          <Box>
            <ModalFooter
              form="delete-util"
              request={loading}
              btn="Delete Util"
            />
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default DeleteUtil;
